import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Floating Action Button (FAB) for Mobile
 * Quick access to compose email on mobile devices
 */
import React from 'react';
import { Plus, Edit } from 'lucide-react';
export const FloatingActionButton = ({ onClick, icon = 'edit', ariaLabel = 'Compose email' }) => {
    const Icon = icon === 'plus' ? Plus : Edit;
    return (_jsx("button", { className: "fab", onClick: onClick, "aria-label": ariaLabel, type: "button", children: _jsx(Icon, { className: "fab-icon" }) }));
};
export default FloatingActionButton;
